import React, { forwardRef, useImperativeHandle } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MonthlyReportPDF = forwardRef(({ reportInfo, tableData }, ref) => {
  useImperativeHandle(ref, () => ({
    generatePDF,
  }));

  const generatePDF = () => {
    const doc = new jsPDF();
    const marginLeft = 14;

    // --- Header ---
    doc.setFontSize(16);
    doc.setTextColor(33);
    doc.setFont('helvetica', 'bold');
    doc.text("Monthly Report", 105, 20, { align: 'center' });

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.text("Under Right to Public Service Act, 2015", 105, 28, { align: 'center' });

    doc.setDrawColor(180);
    doc.line(marginLeft, 32, 200, 32);

    // --- Office Info ---
    const leftColumn = [
      `Location: ${reportInfo.location}`,
      `Branch: ${reportInfo.branchName}`,
      `Month: ${reportInfo.month}`,
    ];
    const rightColumn = [
      `Office: ${reportInfo.officeName}`,
      `District: ${reportInfo.district}`,
      `Year: ${reportInfo.year}`,
    ];
    const infoStartY = 38;
    leftColumn.forEach((line, i) => doc.text(line, marginLeft, infoStartY + i * 7));
    rightColumn.forEach((line, i) => doc.text(line, 120, infoStartY + i * 7));

    // --- Table ---
    const tableStartY = infoStartY + leftColumn.length * 7 + 10;
    autoTable(doc, {
      startY: tableStartY,
      head: [[
        "Sr. No.", "Service Name", "Timeline", "Pending (Previous Month)", "Received (Current Month)", "Total",
        "Disposed (in time)", "Disposed (late)", "Pending(current Month)", "Rejected (w/ reason)", "Rejected (w/o reason)"
      ]],
      body: tableData,
      styles: { fontSize: 8, cellPadding: 2, valign: 'middle' },
      headStyles: {
        fillColor: [52, 152, 219],
        textColor: 255,
        halign: 'center',
        fontStyle: 'bold',
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { halign: 'center', cellWidth: 12 },
        1: { cellWidth: 30 },
        2: { halign: 'center', cellWidth: 18 },
        3: { halign: 'center' },
        4: { halign: 'center' },
        5: { halign: 'center' },
        6: { halign: 'center' },
        7: { halign: 'center' },
        8: { halign: 'center' },
        9: { halign: 'center' },
        10: { halign: 'center' },
      },
      margin: { left: marginLeft },
    });

    // --- Summary ---
//    const summaryY = doc.lastAutoTable.finalY + 10;
//    doc.setFontSize(11);
//    doc.setFont('helvetica', 'bold');
//    doc.text("Summary Insights", marginLeft, summaryY);
//
//    const totalApplications = tableData.reduce((sum, row) => sum + Number(row[5]), 0);
//    const totalDisposed = tableData.reduce((sum, row) => sum + Number(row[6]) + Number(row[7]), 0);
//    const totalRejected = tableData.reduce((sum, row) => sum + Number(row[9]) + Number(row[10]), 0);
//
//    const efficiency = totalApplications ? ((totalDisposed / totalApplications) * 100).toFixed(1) : "0.0";
//    const rejectionRate = totalApplications ? ((totalRejected / totalApplications) * 100).toFixed(1) : "0.0";
//
//    const summaryLines = [
//      `Total Applications this Month: ${totalApplications}`,
//      `Applications Disposed (In + Late): ${totalDisposed}`,
//      `Total Rejected Applications: ${totalRejected}`
//
//    ];
//
//    doc.setFontSize(9);
//    doc.setFont('helvetica', 'normal');
//    summaryLines.forEach((line, i) => {
//      doc.text(line, marginLeft, summaryY + 7 + i * 6);
//    });
//
//    // --- Divider ---
//    const chartY = summaryY + 7 + summaryLines.length * 6 + 10;
//    doc.setDrawColor(200);
//    doc.line(marginLeft, chartY - 6, 200, chartY - 6);
//
//    // --- Visual Representation ---
//    doc.setFontSize(11);
//    doc.setFont('helvetica', 'bold');
//    doc.text("Visual Representation", marginLeft, chartY);
//
//    const chartData = [
//      { label: "Total", value: totalApplications, color: [52, 152, 219] },
//      { label: "Disposed", value: totalDisposed, color: [46, 204, 113] },
//      { label: "Rejected", value: totalRejected, color: [231, 76, 60] },
//    ];
//
//    const maxValue = Math.max(...chartData.map(d => d.value));
//    const chartBarStartX = marginLeft + 50;
//    const chartWidth = 100;
//    const barHeight = 6;
//    const barSpacing = 12;
//
//    chartData.forEach((item, i) => {
//      const barLength = (item.value / maxValue) * chartWidth;
//      const barY = chartY + 8 + i * barSpacing;
//
//      // Colored Bar
//      doc.setFillColor(...item.color);
//      doc.rect(chartBarStartX, barY, barLength, barHeight, 'F');
//
//      // Label and Value with %
//      const percentage = totalApplications ? ((item.value / totalApplications) * 100).toFixed(1) : "0.0";
//      doc.setTextColor(0);
//      doc.setFontSize(9);
//      doc.text(`${item.label}: ${item.value} (${percentage}%)`, marginLeft, barY + 5);
//    });

    // --- Footer ---
    doc.setFontSize(8);
    doc.setTextColor(100);
    doc.text("Generated by Service Report System © 2025", marginLeft, 285);

    doc.save("Monthly_Report.pdf");
  };

  return null;
});

export default MonthlyReportPDF;
